import { defineComponent } from "vue";

const QuantitySelector = defineComponent({
  name: "quantity-selector",
  props: {
    initial: Number,
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 99,
    },
    ariaLabelledby: {
      type: String,
      default: "Quantity",
    },
  },
  data: function () {
    return {
      value: this.initial,
    };
  },
  watch: {
    initial(value: number) {
      this.value = value;
    },
    value: function () {
      if (this.value < this.min) {
        this.value = this.min;
        return;
      }

      if (this.value > this.max) {
        this.value = this.max;
        return;
      }

      this.$emit("change", this.value);
    },
  },
  methods: {
    incrementDown() {
      this.value = this.value -= 1;
    },
    incrementUp() {
      this.value = this.value += 1;
    },
  },
  computed: {},
  template: `
  <div class="quantity-selector">
    <button
      class="quantity-selector__action"
      type="button"
      v-on:click="incrementDown"
      :disabled="value <= min"
      aria-label="Reduce product quantity by one">
      <svg width="10" height="6" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <path d="M-.2-4.2H11V7H-.2z"/>
          <path d="M.6 1.8h9.051V.6H.6z" fill="#161617"/>
        </g>
      </svg>
    </button>
    <label class="sr-only" for="product-quantity-input">Quantity</label>
    <input
      class="quantity-selector__field p1"
      type="number"
      v-model="value"
      maxlength="2"
      id="product-quantity-input"
      name="quantity"
    >
    <button
      class="quantity-selector__action"
      type="button"
      v-on:click="incrementUp"
      :disabled="value >= max"
      aria-label="Increase product quantity by one">
      <svg width="10" height="10" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.668.851v3.817H.85v1.167h3.817V9.65h1.167V5.835H9.65V4.668H5.835V.85z" fill="#161617" fill-rule="evenodd"/>
      </svg>
    </button>
  </div>
  `,
});

export default QuantitySelector;
